"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReferenceEmptyValue = void 0;
const getReferenceEmptyValue = () => [];
exports.getReferenceEmptyValue = getReferenceEmptyValue;
